export default __webpack_public_path__ + "static/media/sports23.f3fc5507.jpg";